export default "__VITE_ASSET__DYQQwAjv__"